var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChildLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0049 39.0098C32.2892 39.0098 39.0049 32.294 39.0049 24.0098C39.0049 15.7255 32.2892 9.00977 24.0049 9.00977C15.7206 9.00977 9.00488 15.7255 9.00488 24.0098C9.00488 32.294 15.7206 39.0098 24.0049 39.0098Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7848 21.9598C26.9048 22.8398 26.9048 24.2598 27.7848 25.1398C28.6648 26.0198 30.0848 26.0198 30.9648 25.1398C31.8448 24.2598 31.8448 22.8398 30.9648 21.9598C30.0848 21.0798 28.6648 21.0798 27.7848 21.9598Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0448 21.9598C16.1648 22.8398 16.1648 24.2598 17.0448 25.1398C17.9248 26.0198 19.3448 26.0198 20.2248 25.1398C21.1048 24.2598 21.1048 22.8398 20.2248 21.9598C19.3448 21.0798 17.9248 21.0798 17.0448 21.9598Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8944 9.15955C22.6844 8.88955 19.8644 11.2696 19.6044 14.4796C19.4144 16.7596 21.1044 18.7695 23.3844 18.9595C25.0044 19.0995 26.5944 17.8496 26.8044 16.2296C26.9544 15.0496 26.7844 13.6795 25.2544 13.4595C24.1744 13.2995 23.4444 13.9595 23.2544 14.8095",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5752 29.4902C19.5752 29.4902 20.6552 31.7502 23.9952 31.7502C27.3352 31.7502 28.3452 29.4902 28.3452 29.4902",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChildLight);
export default __webpack_public_path__ + "static/media/icon_child_light.7ea57ff1.svg";
export { ForwardRef as ReactComponent };